<svg viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 0H3C1.34 0 0 1.34 0 3V4V6V11C0 12.66 1.34 14 3 14H17C18.66 14 20 12.66 20 11V6V4V3C20 1.34 18.66 0 17 0ZM18 11C18 11.55 17.55 12 17 12H3C2.45 12 2 11.55 2 11V6H18V11ZM2 4V3C2 2.45 2.45 2 3 2H17C17.55 2 18 2.45 18 3V4H2Z" fill="#7B61FF"/>
</svg>
